import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { getPageMd } from '../../i18n/pages';
import './Banner.css';

function Banner() {
  const { i18n, t } = useTranslation();
  const lang = i18n.language;
  const history = useHistory();
  const content = getPageMd('banner', lang);
  const handleLoadCXBT = () => {
    history.push('/cxbt');
  };
  return (
    <div className="bannerParentDiv">
      <div className="bannerChildDiv">
        <div className="banner">
          <img
            src={`${process.env.PUBLIC_URL || ''}/assets/images/banner.png`}
            alt="CXB Banner"
          />
        </div>
        <div
          className="banner"
          style={{ marginTop: '16px', paddingTop: '16px' }}
        >
          <ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>
        </div>
        <div className="loadMoreWrap">
          <button
            type="button"
            className="loadMoreBtn"
            onClick={handleLoadCXBT}
          >
            {t('banner.readMore')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default Banner;
